import { Typography, OTP } from "mobily-ui-library";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../context/GlobalContext";

import Error from "../../components/Error/Error";

import { encrypt } from "../../util";
import { FormRedirect } from "../../util/FormRedirect";
import { resendOtp, validateAuth } from "../../api/api";

import RequestIcon from '../../assets/RequestCredit.svg';
import "./LoginOTP.scss";

const win: any = window;

function LoginOTP() {
    const { t } = useTranslation();
    const { state, dispatch }: any = useContext(GlobalContext);

    const [error, setError] = useState("");
    const [second, setSecond] = useState(30);
    const [subError, setSubError] = useState("");
    const [otpValue, setOTPValue] = useState("");

    const { rtl, msisdn, refId, returnUrl, token, bmcs } = state;

    useEffect(() => {
        let timer: any;
        if (second > 0) {
            timer = setTimeout(() => setSecond(second - 1), 1000);
        } else {
            setSecond(0);
        }

        return () => clearTimeout(timer)
    }, [second]);

    const handleSendAgain = () => {
        setSecond(30);
        setError("");
        setSubError("");
        dispatch({ type: "LOADER", payload: { loading: true } });

        const data = {
            "operation": "RESEND_OTP",
            "extraInfo": [
                {
                    "key": "REF_ID",
                    "value": refId
                }
            ]
        }

        resendOtp(data)
            .then((res: any) => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                if (res.status === 204) {
                    setOTPValue("");
                } else {
                    window.location = win['errorPageUrl'];
                }
            })
            .catch(() => {
                setTimeout(() => {
                    window.location = win['errorPageUrl']
                }, 3000)
            })
    }

    const handleOtpChange = (value: any) => {
        const pattern = /^[0-9]{4}/;
        const result = pattern.test(value);

        if (value !== "") {
            if (result) {
                dispatch({ type: "LOADER", payload: { loading: true } });

                const data = {
                    "operation": "VALIDATE_LOGIN_BY_OTP",
                    "extraInfo": [
                        {
                            "key": "REF_ID",
                            "value": refId
                        },
                        {
                            "key": "OTP",
                            "value": value
                        },
                        {
                            "key": "IS_OAUTH_TOKEN",
                            "value": token === '2' ? "Y" : "N"
                        },
                        {
                            "key": "CLIENT_ID",
                            "value": encrypt(win["BM_CLIENT_ID"])
                        },
                        {
                            "key": "CLIENT_SECRET",
                            "value": encrypt(bmcs)
                        }
                    ]
                };

                validateAuth(data)
                    .then((res: any) => {
                        setOTPValue("");
                        if (res.status === 200) {
                            const formData = {
                                JWTToken: res.data.data.access_token,
                                xCoId: res?.config?.headers['X-Correlation-Id']
 
                            }
                            FormRedirect({ returnUrl, formData })
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            setError(rtl ? '' : res.data.status.sourceMessage);
                            setSubError(res.data.status[`message${rtl ? 'Ar' : 'En'}`]);
                        }
                    })
                    .catch(() => {
                        setTimeout(() => {
                            window.location = win['errorPageUrl']
                        }, 3000)
                    })
                setOTPValue("");
            }
        }

        setOTPValue(value)
    }

    const handleError = () => {
        setError("");
        setSubError("");
        setOTPValue('');

        if (second > 0) {
            setSecond(0);
        }
    }

    return (
        <>
            {(error || subError) && (
                <Error
                    rtl={rtl}
                    errorHeading={error}
                    errorSubHeading={subError}
                    handleErrorBtnClick={handleError}
                />
            )}
            <div className={rtl ? "container EasyLogin__allThePage EL_right" : "container EasyLogin__allThePage"}>
                <div className='row'>
                    <div className="EL-text">
                        <img className="theIcon" src={RequestIcon} alt="icon" />
                        <Typography rtl={rtl} className="heading">{t("We_need_to_know")}</Typography>
                        <Typography rtl={rtl} className="sub-heading">{t('OTP_send_to_you')} <span>{`+${msisdn}`}</span></Typography>
                        <Typography rtl={rtl} className="sub-heading">{t('Enter_it_below')}</Typography>
                    </div>

                    <div className="theLine"></div>
                    <div className="otp-container">
                        <OTP
                            className="otpClass"
                            numInputs={4}
                            value={otpValue}
                            isDisabled={false}
                            onChange={handleOtpChange}
                        />
                    </div>

                    {second > 0 ? (
                        <Typography rtl={rtl} className="otp-text" >
                            {t("Request_new_code")}
                            <span>{0}:{second < 10 ? `0${second}` : second}</span>
                        </Typography>
                    ) : (
                        <Typography rtl={rtl} className="didnt_recieve">
                            {t("Didnt_recieve_code")}
                            <span onClick={handleSendAgain}>{t("Send_again")}</span>
                        </Typography>
                    )}
                </div>
            </div>
        </>
    );
}

export default LoginOTP;
